export default {
  services: {},
  add(name: string, service: any): void {
    this.services[name] = service;
  },
  get(name: string): any {
    return this.services[name];
  },
};
